import type { DocMigration } from "../docMigration";

enum CMUBlockType {
  CMU_4_INCH = "CMU_4_INCH",
  CMU_6_INCH = "CMU_6_INCH",
  CMU_8_INCH = "CMU_8_INCH",
  CMU_10_INCH = "CMU_10_INCH",
  CMU_12_INCH = "CMU_12_INCH",
}

interface CMUBlock {
  readonly blockType: CMUBlockType;
  readonly prettyName: string;
  readonly width: number;
  readonly height: number;
  readonly length: number;
}

const CMUBlockCatalog: {
  [K in CMUBlockType]: CMUBlock;
} = {
  [CMUBlockType.CMU_4_INCH]: {
    blockType: CMUBlockType.CMU_4_INCH,
    prettyName: '4" CMU Typ',
    width: 4,
    height: 8,
    length: 16,
  },
  [CMUBlockType.CMU_6_INCH]: {
    blockType: CMUBlockType.CMU_6_INCH,
    prettyName: '6" CMU Typ',
    width: 6,
    height: 8,
    length: 16,
  },
  [CMUBlockType.CMU_8_INCH]: {
    blockType: CMUBlockType.CMU_8_INCH,
    prettyName: '8" CMU Typ',
    width: 8,
    height: 8,
    length: 16,
  },
  [CMUBlockType.CMU_10_INCH]: {
    blockType: CMUBlockType.CMU_10_INCH,
    prettyName: '10" CMU Typ',
    width: 10,
    height: 8,
    length: 16,
  },
  [CMUBlockType.CMU_12_INCH]: {
    blockType: CMUBlockType.CMU_12_INCH,
    prettyName: '12" CMU Typ',
    width: 12,
    height: 8,
    length: 16,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_424: DocMigration = {
  maxSchemaVersion: "0.0.424",
  description: "Change stem wall width and brick ledge width to a number",
  apply(json: any) {
    if (json.settings) {
      for (const settingId in json.settings) {
        const setting = json.settings[settingId];
        if (setting.type === "FOUNDATION_CATALOG_SETTINGS") {
          for (const componentId in setting.foundationComponents) {
            const component = setting.foundationComponents[componentId];
            if (component.componentType === "STEMWALL" && component.catalogItemType === "FOUNDATION_COMPONENT") {
              if (component.stemWallType === "CMU") {
                let stemWallBlockWidth: number | undefined;
                if (component.stemWallBlockType) {
                  stemWallBlockWidth = CMUBlockCatalog[component.stemWallBlockType]?.width;
                  delete component.stemWallBlockType;
                }
                component["stemWallBlockWidth"] = stemWallBlockWidth ?? CMUBlockCatalog[CMUBlockType.CMU_8_INCH].width; // default to CMUBlockCatalog[CMUBlockType.CMU_8_INCH].width

                let stemWallBrickLedgeBlockWidth: number | undefined;
                if (component.brickLedgeBlockType) {
                  stemWallBrickLedgeBlockWidth = CMUBlockCatalog[component.brickLedgeBlockType].width;
                  delete component.brickLedgeBlockType;
                }
                component["stemWallBrickLedgeBlockWidth"] =
                  stemWallBrickLedgeBlockWidth ?? CMUBlockCatalog[CMUBlockType.CMU_12_INCH].width; // default to CMUBlockCatalog[CMUBlockType.CMU_12_INCH].width
              }
            }
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_424;
